/* eslint-disable @typescript-eslint/no-misused-promises */
import { useCallback, useMemo } from 'react';

import classNames from 'classnames';

import noop from '@picsart/rc/noop';

import CopyButton from 'components/CopyButton';
import type { ShareButtonsType } from 'components/ShareButtons/types';
import { ANALYTICS_NAMES } from 'templates/components/SingleTemplate/constants';

import useCopyToClipboard from 'hooks/useCopyToClipboard';
import ShareButton from './ShareButton';
import { POPUP_SHARE_BUTTONS } from './constants';
import { useShareButtonsStyles } from './styles';

const ShareButtons = ({
  analyticsPageClick = noop,
  imageViewPageUrl,
  compactMode,
  position,
  onClick,
  license,
  className,
}: ShareButtonsType) => {
  const styles = useShareButtonsStyles();

  const [isCopied, onCopyToClipboard] = useCopyToClipboard();

  const shareEnabled = true;

  const handleCopyClick = useCallback(async () => {
    const { ACTION_BUTTON } = await import('services/Analytics/templateAnalytics/config');

    analyticsPageClick(ACTION_BUTTON.copy_link, position);
    onCopyToClipboard(imageViewPageUrl);
  }, [analyticsPageClick, imageViewPageUrl, onCopyToClipboard, position]);

  const filteredButtons = useMemo(
    () =>
      shareEnabled
        ? POPUP_SHARE_BUTTONS
        : POPUP_SHARE_BUTTONS.filter(button => button.isAllowedInForbiddenCounties),
    [shareEnabled],
  );

  return (
    <ul
      className={classNames(styles.root, { compact: compactMode }, className)}
      data-testid="share-button"
      data-pulse-section={ANALYTICS_NAMES.SHERE_COPY_BUTTON}
    >
      <CopyButton compactMode={compactMode} isActive={isCopied} onClick={handleCopyClick} />
      {filteredButtons.map(({ label, svgName, smType }) => (
        <ShareButton
          license={license}
          analyticsPageClick={analyticsPageClick}
          imageViewPageUrl={imageViewPageUrl}
          compactMode={compactMode}
          position={position}
          onClick={onClick}
          svgName={svgName}
          smType={smType}
          label={label}
          key={label}
        />
      ))}
    </ul>
  );
};

export default ShareButtons;
